import { render } from "./KeywordsAutoscroll.vue?vue&type=template&id=55950372"
import script from "./KeywordsAutoscroll.vue?vue&type=script&lang=js"
export * from "./KeywordsAutoscroll.vue?vue&type=script&lang=js"

import "./KeywordsAutoscroll.vue?vue&type=style&index=0&id=55950372&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__